import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';

import { getAccount, subscribeToAccountChange, subscribeToNeworkConnect } from '../web3/web3';
import { useCallback } from 'react';
import { getBalance } from '../web3/account';

export const accountSlice = createSlice({
    name: 'account',
    initialState: {
        account: null,
        connected: false,
        nativeBalance: 0,
    },
    reducers: {
        setAccount: (state, action) => {
            state.account = action.payload;
        },
        setNativeBalance: (state, action) => {
            state.nativeBalance = action.payload;
        },
        setConnected: (state, action) => {
            state.connected = action.payload;
        },
    },
});

export const { setAccount, setConnected, setNativeBalance } = accountSlice.actions;

export const useNativeBalance = () => {
    const dispatch = useDispatch();
    const account = useAccount();

    const refresh = useCallback(async () => {
        if (!account) {
            dispatch(setNativeBalance(0));
            return;
        }
        const nativeBalance = await getBalance('BNB', account);
        dispatch(setNativeBalance(nativeBalance));
    }, [account])

    useEffect(() => refresh(), [account]);

    const balance = useSelector(state => state.account.nativeBalance);

    return [balance, refresh];
}
export const useAccount = () => {
    const dispatch = useDispatch();
    const account = useSelector(state => state.account.account);
    const _connected = useSelector(state => state.account.connected);

    useEffect(() => {
        const initAccount = async () => {
            const _account = await getAccount();
            dispatch(setAccount(_account));
        };
        subscribeToAccountChange('account-slice', (account) => {
            dispatch(setAccount(account));
        });
        subscribeToNeworkConnect('account-slice', (connected) => {
            dispatch(setConnected(!!connected));
            if (!!connected) {
                initAccount();
            }

        });
    }, [dispatch]);
    return _connected && account;
};


export default accountSlice.reducer;